var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 11h-9.54A6 6 0 0 0 34 1c-3.08 0-5.07 1.18-7.08 4.2C26.44 5.91 25 8.4 24 10c-1-1.6-2.44-4.09-2.92-4.8-2-3-4-4.2-7.08-4.2a6 6 0 0 0-4.46 10H0v10h4.07l1.36 17.69a9 9 0 0 0 9 8.31h19.16a9 9 0 0 0 9-8.31L43.93 21H48V11ZM28.58 6.3C30.23 3.83 31.6 3 34 3a4 4 0 0 1 0 8h-8.25c.95-1.61 2.39-4 2.83-4.7ZM10 7a4 4 0 0 1 4-4c2.4 0 3.77.83 5.42 3.3.44.7 1.88 3.09 2.83 4.7H14a4 4 0 0 1-4-4Zm-8 6h21v6H2v-6Zm5.43 25.54L6.08 21H23v24h-8.59a7 7 0 0 1-6.98-6.46Zm33.14 0a7 7 0 0 1-7 6.46H25V21h16.92ZM46 19H25v-6h21v6Z"
  })));
};
export default SvgGift;